import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect, useState } from "react";
import useHttp from "../../hooks/useHttp";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const testing = process.env.REACT_APP_TEST_MODE === "test";

interface InteractionScheduleReportProps {
    anchorID: number | string;
    headers: Array<any>;
    rows: Array<any>;
    title: string;
    subjectID?: string | number;
    omittedFields?: Array<string> | undefined
}

const InteractionScheduleReport = (props: InteractionScheduleReportProps) => {
    const { isLoading, sendRequest: fetchData } = useHttp();
    const [headers, setHeaders] = useState<Array<any>>([])
    const [rows, setRows] = useState<Array<any>>([])

    const [expanded, setExpanded] = useState<string | false>(false);

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    const fetchReport = async () => {
        let url: string =
            process.env.REACT_APP_API_URL + "/interaction_schedule_readable?anchor_id=eq." + props.anchorID;
        switch (props.title) {
            case "Interaction Communication Readable":
                url = process.env.REACT_APP_API_URL + "/interaction_communication_readable?anchor_id=eq." + props.anchorID;
                break;
            case "Interaction Schedule Readable":
                url = process.env.REACT_APP_API_URL + "/interaction_schedule_readable?anchor_id=eq." + props.anchorID;
                break;
            case "Possible Contacts":
                url = process.env.REACT_APP_API_URL + "/possible_contact_readable?anchor_id=eq." + props.anchorID;
                break;
            case "Contact Log":
                url = process.env.REACT_APP_API_URL + "/contact_log?subject_id=eq." + props.subjectID;
                break;
            default:
                url = process.env.REACT_APP_API_URL + "/interaction_schedule_readable?anchor_id=eq." + props.anchorID;
        }

        const requestSettings = {
            url: url,
            method:"GET",
            headers: {
                Authorization: "Bearer " + process.env.REACT_APP_POSTGREST_JWT,
                "Accept-Profile": testing ? "test" : "build"
            },
        };
        await fetchData(requestSettings, (data: Array<any>) => {
            // need to add in IDs so it works with the data grid
            let count = 0;
            const interactionSchedule = data.map((item) => {
                item.id = count;
                count++;
                return item;
            })
            // remove omitted fields from data
            props.omittedFields?.forEach((field:any)=>{
                delete interactionSchedule[field];
            })
            
            setRows(interactionSchedule)
            if (interactionSchedule.length > 0) {
                const headers = Object.keys(interactionSchedule[0]);
                // remove omitted fields from headers
                const filteredHeaders = headers.filter(item => !props.omittedFields?.includes(item));
                setHeaders(filteredHeaders);
            }
        })
    }

    useEffect(() => {
        const fetch = async () => {
            await fetchReport()
        }
        fetch();
    }, [])


    return (
        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
            >
                <h3>{props.title}</h3>
            </AccordionSummary>

            <AccordionDetails>
                <Box sx={{ padding: "10px" }}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="dynamic table">
                            <TableHead>
                                <TableRow>
                                    {headers.map((header) => (
                                        <TableCell key={header} align="center" sx={{ border: "1pt solid lightgray", fontWeight: "bold" }}>
                                            {header.replace(/_/g, ' ').toUpperCase()}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.length < 1 && <div style={{ border: "1pt solid lightgray", padding: "10px" }}>No Data Available</div>}
                                {rows.map((row, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                        {headers.map((header) => (
                                            <TableCell sx={{ border: "1pt solid lightgray" }} key={header} align="left">
                                                {typeof row[header] === 'object' ? JSON.stringify(row[header]) : row[header] + ""}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </AccordionDetails>
        </ Accordion>
    )
}

export default InteractionScheduleReport

